import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useOfficialDailyDispatch } from "./official-daily-context";
import { IListOfficialDailyRequest } from "../../../model/base/request/list-official-daily-request";

export const useOfficialDailyController = () => {
    const OfficialDailyDispatch = useOfficialDailyDispatch();

    async function loadData(request: IListOfficialDailyRequest) {
        try {
            OfficialDailyDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.listOfficialDaily(request);

            OfficialDailyDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar edições do Diário Oficial:', error);
            OfficialDailyDispatch({
                type: ACTION_TYPES.setLoading,
                payload: false,
            });
        }
    }

    function clearData() {
        OfficialDailyDispatch({
            type: ACTION_TYPES.clearData,
        });
    }

    return {
        loadData,
        clearData
    };
}
